import React, { useEffect, useRef, useState } from 'react';
import {
  CloseButton,
  Container,
  List,
  Title,
  Wrapper,
  GamesWrapper,
  MatchBox,
  MatchTab
} from './styled';
import HotMatchStore from './store';
import { observer } from 'mobx-react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import ScoreTypeView from '../view';
import clsx from 'clsx';
import moment from 'moment';

const HotMatchLayer = observer(
  ({
    viewHotLayer,
    handleToggleSetViewHotLayer,
    selectedGames,
    setSelectedGame,
    fromHome
  }) => {
    const { getMatches, closeSocket, matchList } = HotMatchStore();
    const layerComp = useRef();
    useEffect(() => {
      return () => {
        closeSocket();
        enableBodyScroll(layerComp.current);
      };
    }, []);

    const handleCloseLayer = () => {
      handleToggleSetViewHotLayer();
    };

    useEffect(() => {
      if (viewHotLayer) {
        getMatches();
        disableBodyScroll(layerComp.current);
      } else {
        enableBodyScroll(layerComp.current);
        closeSocket();
      }
    }, [viewHotLayer]);

    let dateComps = [];
    matchList.map((value, key) => {
      dateComps.push(
        <DateMatches
          key={key}
          value={value}
          selectedGames={selectedGames}
          setSelectedGame={setSelectedGame}
          fromHome={fromHome}
        />
      );
    });

    return (
      <Container isActive={viewHotLayer}>
        <Title>
          핫 경기
          <CloseButton onClick={handleCloseLayer} />
        </Title>
        <Wrapper ref={layerComp}>
          <List>{dateComps}</List>
        </Wrapper>
      </Container>
    );
  }
);

const DateMatches = observer(({ value, selectedGames, setSelectedGame, fromHome }) => {
  const [viewToggle, setViewToggle] = useState(true);
  const handleToggle = () => {
    setViewToggle(!viewToggle);
  };

  const { date, games } = value;
  const formattedDateTime = moment(date)
    .locale('ko')
    .format('YYYY년 MM월 DD일 (ddd)');

  return (
    <MatchBox>
      <MatchTab onClick={handleToggle} isClose={!viewToggle}>
        {formattedDateTime}
      </MatchTab>
      <GamesWrapper isActive={viewToggle}>
        {games.map((value, key) => {
          const { sportsType } = value;
          return (
            <div className="section" key={key}>
              <div className="top">
                <strong className={clsx('tit', 'hot')}>
                  {value.league.shortName}
                </strong>
              </div>
              <ScoreTypeView
                sportsType={sportsType}
                item={value}
                setSelectedGame={setSelectedGame}
                isSelected={selectedGames.some((id) => id === value.id)}
                fromHome={fromHome}
              />
            </div>
          );
        })}
      </GamesWrapper>
    </MatchBox>
  );
});

export default HotMatchLayer;
